<div id="body">
  <header class="clearfix">
    <div id="logo">
      <img src="../../../../assets/images/logo.png" />
    </div>
    <div id="company">
      <h2 class="name">N° de remorque {{ trailer?.remorqueId }}</h2>
      <div><b>Date : </b>{{ trailer?.creation_date | date: "d MMM y" }}</div>
      <div><b>Devise : €</b></div>
    </div>
  </header>
  <main>
    <div id="details" class="clearfix">
      <div id="client">
        <!-- <h2 class="name">{{cmd.client_cmd?.providerName}}</h2> -->
        <table style="margin-bottom: 5px">
          <tbody>
            <tr>
              <td class="header header-bold">Transporteur:</td>
              <td class="header">
                {{ trailer.transportor?.firstName }}
                {{ trailer.transportor?.lastName }}
              </td>
            </tr>
            <tr>
              <td class="header header-bold">Transportor Type:</td>
              <td class="header">
                {{ trailer.transportorType }}
              </td>
            </tr>
            <tr>
              <td class="header header-bold">Plateforme:</td>
              <td class="header">
                {{ trailer.plateform }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div id="invoice">
        <qrcode
          print
          [width]="150"
          usesvg="true"
          [elementType]="'svg'"
          [qrdata]="trailer._id"
          [errorCorrectionLevel]="'M'"
        >
        </qrcode>
      </div>
    </div>
    <table border="0" cellspacing="0" cellpadding="0">
      <thead>
        <tr style="border: 1px solid">
          <th class="title-table"></th>
          <th class="title-table">Label</th>
          <th class="title-table">Valeur</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of trailer.invoiceTaxes; let index = index">
          <td class="ref">{{ index + 1 }}</td>
          <td class="desc">{{ item.label }}<br /></td>
          <td class="qty">
            <b>{{ item.value | number: "0.3" }} €</b>
          </td>
        </tr>

        <tr>
          <td colspan="3" style="border: none; height: 30px"></td>
        </tr>
        <tr>
          <td colspan="3" style="border: none; height: 20px"></td>
        </tr>
        <tr class="tfooter">
          <td colspan="1" style="border: none"></td>
          <td colspan="1" class="center-td" style="font-weight: bold">Total</td>
          <td>
            <b>{{ trailer?.totalCost | number: "0.3" }} €</b>
          </td>
        </tr>
        <tr class="tfooter">
          <td colspan="1" style="border: none"></td>
          <td colspan="1" class="center-td" style="font-weight: bold">
            Volume total
          </td>
          <td>
            <b>{{ trailer?.totalVolume | number: "0.3" }} m³</b>
          </td>
        </tr>
        <tr class="tfooter">
          <td colspan="1" style="border: none"></td>
          <td colspan="1" class="center-td" style="font-weight: bold">
            Poids total
          </td>
          <td>
            <b>{{ trailer?.totalWeight | number: "0.3" }} Kg</b>
          </td>
        </tr>
      </tbody>
    </table>
  </main>
</div>
